import { useNavigate, useSearchParams } from "react-router-dom";

const useQueryParams = () => {
  const navigate = useNavigate();

  const [search, setSearchParams] = useSearchParams();

  const { q, co, c, show, dealId, ln, plus } = Object.fromEntries(search);

  // Gear+ URL param. Defaults to "0" (off) when the param is absent, so the
  // Experience category/page stay hidden unless a guest lands with plus=1.
  const gearPlus = plus ?? "0";

  const lastName =
    ln?.length > 1 ? ln.charAt(0).toUpperCase() + ln.slice(1) : "";

  const navigateWithQuery = (url, options = {}) =>
    navigate(isNaN(url) ? `${url}?${search.toString()}` : url, options);

  const redirectWithQuery = (url, options = {}) =>
    navigateWithQuery(url, { ...options, replace: true });

  const removeQueryParam = (param) => {
    if (!param) setSearchParams({});

    const newSeachParams = new URLSearchParams(search);
    newSeachParams.delete(param);
    setSearchParams(newSeachParams);
  };

  return {
    quoteNumber: q,
    coId: co,
    companionId: c,
    show,
    dealId,
    lastName,
    gearPlus,
    isGearPlus: gearPlus === "1",
    navigateWithQuery,
    redirectWithQuery,
    removeQueryParam,
  };
};

export default useQueryParams;
